if (!customElements.get('mr-return-request')) {
  customElements.define('mr-return-request', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.form = this.querySelector('form');
      this.success = this.querySelector('[data-mrr-success]');
      if (this.success) {
        window.location.replace(this.dataset.confirmationUrl);
        return;
      }
      this.details = this.querySelector('[data-mrr-details]');
      if (!this.form || !this.details) return;
      this.submitButton = this.querySelector('.mrr__submit');
      this.customerChoices = this.querySelector('.mrr__customer-type');
      this.businessNotice = this.querySelector('[data-mrr-business]');
      this.actions = this.querySelector('[data-mrr-actions]');
      this.chooseHint = this.querySelector('[data-mrr-choose]');
      this.addEventListener('change', (event) => {
        if (event.target.name === 'contact[Klanttype]') this.updateCustomerType();
      }, { signal });
      this.form.addEventListener('input', (event) => {
        if (event.target.matches('[data-mrr-required]')) event.target.setCustomValidity('');
      }, { signal });
      this.form.addEventListener('submit', (event) => {
        if (this.customerType !== 'Particulier') {
          event.preventDefault();
          this.updateCustomerType();
          return;
        }
        for (const field of this.details.querySelectorAll('[data-mrr-required]')) {
          field.setCustomValidity(field.value.trim() ? '' : field.dataset.mrrRequired);
        }
        if (!this.form.reportValidity()) {
          event.preventDefault();
          this.setSubmitting(false);
          return;
        }
        this.form.querySelector('input[name="return_to"]').value = this.dataset.confirmationUrl;
        this.setSubmitting(true);
      }, { signal });
      this.form.addEventListener('invalid', () => this.setSubmitting(false), { signal, capture: true });
      this.submitButton.addEventListener('click', (event) => {
        if (this.submitting) event.preventDefault();
      }, { signal });
      window.addEventListener('pageshow', () => this.setSubmitting(false), { signal });
      this.updateCustomerType();
      this.setSubmitting(false);
    }

    get customerType() {
      return this.querySelector('input[name="contact[Klanttype]"]:checked')?.value;
    }

    updateCustomerType() {
      const isPrivate = this.customerType === 'Particulier';
      const isBusiness = this.customerType === 'Zakelijk';
      this.details.hidden = !isPrivate;
      this.details.disabled = !isPrivate;
      this.actions.hidden = !isPrivate;
      this.businessNotice.hidden = !isBusiness;
      this.chooseHint.hidden = isPrivate || isBusiness;
    }

    setSubmitting(submitting) {
      this.submitting = submitting;
      this.form.setAttribute('aria-busy', String(submitting));
      this.submitButton.setAttribute('aria-busy', String(submitting));
      if (submitting) this.submitButton.setAttribute('aria-disabled', 'true');
      else this.submitButton.removeAttribute('aria-disabled');
      this.details.inert = submitting;
      this.customerChoices.inert = submitting;
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
